<template>
	<div>
		<Modal 
			:loading="loading" 
			:title="'USUÁRIO'"
			@close="close"
			@save="save"
		>
			<div class="row">
				<div v-if="current.is_admin" class="col-xs-12">
					<p class="description"><b><i class="fa fa-fw fa-info-circle"></i> Atenção:</b> Este usuário é um administrador</p>
				</div>
				<div class="col-xs" v-if="current != 'new'" style="max-width: 65px;">
					<div class="user-profile-wrapper">
						<img class="user-profile-image" :src="profile_url_computed" />

						<div class="user-profile-loading" v-if="profile_loading">
							<i class="fa fa-circle-notch fa-spin"></i>
						</div>

						<button class="user-profile-change" @click="$refs.profile_input.click()">
							<i class="fa fa-fw fa-upload"></i>
						</button>
					</div>
				</div>
				<div class="col-xs">
					<div class="user-profile-name">
						<FormInput v-model="name" label="Nome" icon="fa-user" :required="current!= 'new' ? true : false" tooltip="Informe o nome do usuário" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs">
					<FormInput v-model="email" label="E-mail" icon="fa-envelope" :required="current!= 'new' ? true : false" tooltip="Informe o e-mail para o acesso do usuário" />
				</div>
			</div>
			<div class="row">
				<div class="col-xs">
					<FormInput v-if="current != 'new'" type="password" v-model="password" label="Senha (deixe em branco para manter)" icon="fa-lock" tooltip="Informe a senha de acesso do usuário" />
					<FormInput v-if="current == 'new'" type="password" v-model="password" label="Senha" icon="fa-lock" :required="current!= 'new' ? true : false" tooltip="Informe a senha de acesso do usuário" />
				</div>
			</div>
			<div v-if="!current.is_admin && ($api.user.id != current.id)" class="row">
				<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
					<FormSelect :options="{1: 'Ativo', 0: 'Inativo'}" v-model="status" label="Status" icon="fa-check" tooltip="Selecione o status do usuário" :required="current!= 'new' ? true : false" />
				</div>
				<div class="col-xs-12 col-sm-12 col-md-offset-2 col-md-4 col-lg-offset-2 col-lg-4">
					<FormCheckbox v-model="user_admin" label="Administrador" icon="fa-user" tooltip="Selecione se o usuário terá acessos de Adminstrador nas seções da empresa" />
				</div>
			</div>
		</Modal>
		<input ref="profile_input" @change="upload_profile" type="file" style="display: none;" accept="image/*" />
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";
import FormCheckbox from "@/components/FormCheckbox";

const default_profile_picture = require("@/assets/user.png");

export default {
	name: "ConfigUsersForm",

	props: { 
		current: {
			type: [Object, String],
			require: true
		}
	},

	components: {
		Modal,
		FormInput,
		FormSelect,
		FormCheckbox,
	},

	data: function() {
		if (this.current != 'new') {
			return {
				loading: false,

				id: this.current.id,
				email: this.current.email,
				name: this.current.name,
				password: '',
				status: this.current.status,

				profile_loading: true,
				profile_url: false,
				
				user_admin: this.current.user_admin,
			}
		}

		return {
			loading: false,

			id: false,
			email: '',
			name: '',
			password: '',
			status: 1,

			profile_loading: true,
			profile_url: false,

			user_admin: 0,

			changeEmail: false,
		}
	},

	computed: {
		profile_url_computed: function() {
			if (this.profile_url) return this.profile_url;
			return default_profile_picture;
		}
	},

	mounted: function() {
		this.load_profile();
	},

	methods: {
		load_profile: async function() {
			this.profile_url = false;
			this.profile_loading = true;
			let res = await Api.blob("user/get-user-photo?user=" + this.id);
			this.profile_url = res;
			this.profile_loading = false;
		},

		upload_profile: async function() {
			if (this.$refs.profile_input.files.length == 0) return;

			this.url = false;

			let file = this.$refs.profile_input.files[0];

			this.profile_url = false;
			this.profile_loading = true;
			let res = await Api.upload("user/send-user-photo?user=" + this.id, { file: file });

			if (res.error) {
				this.$notification.error(res.data);
			} else {
				this.$notification.success("Enviado com sucesso.");
			}

			this.load_profile();
		},

		save: async function() {
			let data;

			if (this.current != 'new') {
				data = this.get_delta();
				if (data == false) {
					this.$notification.success("Nunhuma informação alterada.");
					this.close();
					this.$parent.load();
					return;
				}
			} else {
				data = {
					name: this.name,
					email: this.email,
					password: this.password,
					status: this.status,
					user_admin: this.user_admin,
				}
			}

			if ((this.current != 'new') && (this.$api.user.id == this.current.id) && this.changeEmail) {
				let confirm = await this.$alert.confirm("Devido a alteração do e-mail de acesso, você será desconectado e precisará fazer o login novamente. Deseja continuar?", "AVISO");
				if(!confirm) {
					let confirm2 = await this.$alert.confirm("O seu e-mail de acesso não será alterado, deseja salvar as demais informações?", "AVISO");
					if(confirm2) {
						data.email = null;
						this.changeEmail = false;
					} else {
						this.close();
						this.$parent.load();
						return;
					}
				}
			}

			this.loading = true;
			let res = await Api.post("user/save-user", data);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
			} else {
				this.$notification.success("Informações salvas com sucesso.");
				if ((this.current != 'new') && (this.$api.user.id == this.current.id) && this.changeEmail) {
					await this.$alert.alert("Você será desconectado agora");
					Api.logout();
				} else {
					this.close();
					this.$parent.load();
				}
			}
		},

		get_delta: function() {
			if (!this.id) return false;

			let delta = {};

			if (this.name != this.current.name) {
				delta.name = this.name;
			}

			if (this.email != this.current.email) {
				delta.email = this.email;
				this.changeEmail = true;
			}

			if (this.status != this.current.status) {
				delta.status = this.status;
			}

			if (this.password != '') {
				delta.password = this.password;
			}

			if (this.user_admin != this.current.user_admin) {
				delta.user_admin = this.user_admin;
			}

			if (Object.keys(delta).length == 0) return false;
			
			delta.id = this.id;

			return delta;
		},

		close: function() {
			this.$emit("close");
		}
	}
}
</script>

<style scoped>
.user-profile-wrapper {
    width: 80px;
    height: 80px;
    padding: 15px 0 15px 0;
    position: relative;
}

img.user-profile-image {
    width: 50px;
    height: 50px;
    border-radius: 100%;
}

button.user-profile-change {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 15px;
    left: 0;
    border-radius: 100%;
    border: none;
    opacity: 0;
    background: #000;
    color: #fff;
}

button.user-profile-change:hover {
    opacity: 0.6;
}

.user-profile-loading {
	position: absolute;
	top: 15px;
	left: 0;
	width: 50px;
	height: 50px;
	background: #22222244;
	color: #fff;
	font-size: 30px;
	text-align: center;
	line-height: 50px;
	border-radius: 100%;
}

p.description {
	margin-block-start: 0px;
	margin-block-end: 30px;
	padding: 5px;
	background-color: #f8d7da;
	color: #721c24;
	border-radius: 4px;
	font-size: 12px;
}
</style>